export default __webpack_public_path__ + "66f1d53ee21e39be8591b31d088e2926.svg";